import React from "react";
import { FiTrendingUp, FiTrendingDown } from "react-icons/fi";

const InfoCardVertical = ({
  heading,
  number,
  icon: Icon,
  bottomText,
  bgColor = "bg-red-200",
  iconColor = "text-gray-500",
  trend = null, // { percentage: string, isUp: boolean }
  className = "", // Add className prop with default empty string
}) => {
  return (
    <div className={`p-6 bg-white shadow rounded-lg flex flex-col items-center text-center border border-gray-200 h-86 ${className}`}>
      <h2 className="text-md font-bold text-gray-900 mb-4">{heading}</h2>

      <div className="flex-grow flex items-center mb-4 justify-center h-full w-full">
        {typeof Icon === "string" ? (
          <img
            src={Icon}
            alt=""
            className={`h-40 w-40 object-contain ${bgColor} rounded-[44px] p-4`}
          />
        ) : (
          <Icon
            className={`h-40 w-40 ${iconColor} ${bgColor} min-w-36 rounded-[60px] p-10`}
          />
        )}
      </div>

      <div className="mt-auto flex flex-col items-center">
        <p className="text-3xl font-bold text-gray-900 mb-4">{number}</p>

        {/* Bottom text with automatic trend icon */}
        {trend ? (
          <p className="text-sm text-gray-600 flex items-center gap-1">
            {trend.isUp ? (
              <FiTrendingUp className="w-4 h-4 text-green-600 " />
            ) : (
              <FiTrendingDown className="w-4 h-4 text-red-600" />
            )}
            <span
              className={`font-semibold ${
                trend.isUp ? "text-green-600" : "text-red-600"
              }`}
            >
              {trend.percentage}
            </span>
            <span className="text-gray-500">vs last week</span>
          </p>
        ) : (
          <p className="text-sm text-gray-600">{bottomText}</p>
        )}
      </div>
    </div>
  );
};

export default InfoCardVertical;
